module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "viewContainer"
  }, [(_vm.caseing) ? _c('div', [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "fuji",
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_c('div', {
    staticClass: "goodslist1"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "5px"
    }
  }, [_vm._v("搜索/查询")]), _vm._v(" "), _c('span', {
    staticClass: "divReset",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fnReset($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/Reset.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sanjiao",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-10px"
    }
  })]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }]
  }, [_c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "30%",
      "display": "flex"
    },
    attrs: {
      "label": "案例名称："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请输入案例名称",
      "maxlength": "20"
    },
    model: {
      value: (_vm.expName),
      callback: function($$v) {
        _vm.expName = $$v
      },
      expression: "expName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "30%",
      "display": "flex"
    },
    attrs: {
      "label": "状　　态："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.zhuangtaiid),
      callback: function($$v) {
        _vm.zhuangtaiid = $$v
      },
      expression: "zhuangtaiid"
    }
  }, _vm._l((_vm.statusarr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "30%",
      "display": "flex"
    },
    attrs: {
      "label": "装修风格：",
      "label-width": "45px"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.zffgid),
      callback: function($$v) {
        _vm.zffgid = $$v
      },
      expression: "zffgid"
    }
  }, _vm._l((_vm.shoptype), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "30%",
      "display": "flex"
    },
    attrs: {
      "label": "户　　型："
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "value": _vm.decorationType,
      "options": _vm.optionshx
    },
    on: {
      "change": _vm.handlehx
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "30%",
      "display": "flex"
    },
    attrs: {
      "label": "所属店铺："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择",
      "filterable": ""
    },
    model: {
      value: (_vm.suoshudp),
      callback: function($$v) {
        _vm.suoshudp = $$v
      },
      expression: "suoshudp"
    }
  }, _vm._l((_vm.dianpuArr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "30%",
      "display": "flex"
    },
    attrs: {
      "label": "设计师名称：",
      "label-width": "45px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请输入设计师名称",
      "maxlength": "20"
    },
    model: {
      value: (_vm.sjsName),
      callback: function($$v) {
        _vm.sjsName = $$v
      },
      expression: "sjsName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.findinfo()
      }
    }
  }, [_vm._v("查 询")])], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "main_container"
  }, [_c('section', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("装修案例")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin": "5px 10px 0 0"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.addeditinfo('')
      }
    }
  }, [_vm._v("新 增")])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.goodListInfo,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "type": "index",
      "width": "60",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所属店铺",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.shopName))])]
      }
    }], null, false, 3575735405)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "设计师",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.designerName))]
      }
    }], null, false, 922685599)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "案例标题",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.expName))]
      }
    }], null, false, 657759959)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "风格",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.styleName))]
      }
    }], null, false, 3432481229)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "装修类型",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.workTypeName))]
      }
    }], null, false, 2277468707)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "户型",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.domain))]
      }
    }], null, false, 2679792829)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "面积",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.expSize))]
      }
    }], null, false, 192255701)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "费用",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.expPrice))]
      }
    }], null, false, 883763101)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "施工工期",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.expWorkDay))]
      }
    }], null, false, 1880601773)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.onlineStatus))]
      }
    }], null, false, 3808631590)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "align": "center",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.addeditinfo(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit-outline"
        }), _vm._v(" 编辑\r\n            ")]), _vm._v(" "), _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.onshop(scope.row)
            }
          }
        }, [_c('i', {
          class: scope.row.isOnline == 0 ? 'el-icon-upload2' : 'el-icon-download'
        }), _vm._v("\r\n              " + _vm._s(scope.row.isOnline == 0 ? '上架' : '下架') + "\r\n            ")])]
      }
    }], null, false, 1322210207)
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right",
      "margin": "10px 0"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "current-page": _vm.pageIndex,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])]) : _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading2),
      expression: "loading2"
    }],
    staticClass: "main_container",
    attrs: {
      "element-loading-text": "拼命保存中",
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(255, 255, 255, 0.9)"
    }
  }, [_c('h2', {
    staticClass: "shopTitle"
  }, [_vm._v(_vm._s(_vm.showtype == 1 ? "新增案例" : "编辑案例"))]), _vm._v(" "), _c('div', {
    staticClass: "domDiv"
  }, [_c('p', {
    staticClass: "xmxx"
  }, [_vm._v(" 项目信息 ")]), _vm._v(" "), _c('div', {
    staticClass: "contentDiv"
  }, [_c('el-form', {
    staticClass: "demoFormInline"
  }, [_c('el-form-item', {
    staticClass: "selectflex",
    attrs: {
      "label": "作品分类："
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "options": _vm.optionszpfl
    },
    on: {
      "change": _vm.handlezpfl
    },
    model: {
      value: (_vm.casaarr),
      callback: function($$v) {
        _vm.casaarr = $$v
      },
      expression: "casaarr"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "selectflex",
    attrs: {
      "label": "设计师："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.sjsid),
      callback: function($$v) {
        _vm.sjsid = $$v
      },
      expression: "sjsid"
    }
  }, _vm._l((_vm.sjsArr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.designerid,
        "label": item.designername
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form', {
    staticClass: "demoFormInline"
  }, [_c('el-form-item', {
    staticClass: "selectflex",
    attrs: {
      "label": "作品风格："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.zpfgid),
      callback: function($$v) {
        _vm.zpfgid = $$v
      },
      expression: "zpfgid"
    }
  }, _vm._l((_vm.shoptype), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "selectflex",
    attrs: {
      "label": "面　　积："
    }
  }, [_c('el-input', {
    staticClass: "slotwidth",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "onkeyup": "value=value.replace(/[^\\d\\.]/g,'').replace(/^(\\-)*(\\d+)\\.(\\d\\d).*$/,'$1$2.$3')",
      "placeholder": "单行输入",
      "maxlength": "8"
    },
    on: {
      "blur": function($event) {
        return _vm.ExpSizeblur()
      }
    },
    model: {
      value: (_vm.ExpSize),
      callback: function($$v) {
        _vm.ExpSize = $$v
      },
      expression: "ExpSize"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("㎡")])], 2)], 1)], 1), _vm._v(" "), _c('el-form', {
    staticClass: "demoFormInline"
  }, [_c('el-form-item', {
    staticClass: "selectflex",
    attrs: {
      "label": "工　　期："
    }
  }, [_c('el-input', {
    staticClass: "slotwidth",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "onkeyup": "value=value.replace(/[^\\d\\.]/g,'').replace('.','')",
      "placeholder": "单行输入",
      "maxlength": "8"
    },
    on: {
      "blur": function($event) {
        return _vm.ExpSizeblur()
      }
    },
    model: {
      value: (_vm.ExpWorkDay),
      callback: function($$v) {
        _vm.ExpWorkDay = $$v
      },
      expression: "ExpWorkDay"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("天")])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "selectflex",
    attrs: {
      "label": "工程造价："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "onkeyup": "value=value.replace(/[^\\d\\.]/g,'').replace(/^(\\-)*(\\d+)\\.(\\d\\d).*$/,'$1$2.$3')",
      "placeholder": "单行输入",
      "maxlength": "8"
    },
    on: {
      "blur": function($event) {
        return _vm.ExpSizeblur()
      }
    },
    model: {
      value: (_vm.ExpWorkPrice),
      callback: function($$v) {
        _vm.ExpWorkPrice = $$v
      },
      expression: "ExpWorkPrice"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("万元")])], 2)], 1)], 1), _vm._v(" "), _c('el-form', {
    staticClass: "demoFormInline"
  }, [_c('el-form-item', {
    staticClass: "selectflex",
    attrs: {
      "label": "所属城市："
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择城市",
      "options": _vm.optionssscs,
      "filterable": ""
    },
    on: {
      "change": _vm.handlesscs
    },
    model: {
      value: (_vm.selectedOptions),
      callback: function($$v) {
        _vm.selectedOptions = $$v
      },
      expression: "selectedOptions"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "selectflex",
    attrs: {
      "label": "小区名称："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "maxlength": "20",
      "placeholder": "请输入小区名称"
    },
    model: {
      value: (_vm.ExpAddress),
      callback: function($$v) {
        _vm.ExpAddress = $$v
      },
      expression: "ExpAddress"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    staticClass: "demoFormInline"
  }, [_c('el-form-item', {
    staticClass: "selectflex",
    attrs: {
      "label": "施工方式："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择施工方式 "
    },
    model: {
      value: (_vm.ExpWorkType),
      callback: function($$v) {
        _vm.ExpWorkType = $$v
      },
      expression: "ExpWorkType"
    }
  }, _vm._l((_vm.stylearr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "selectflex",
    attrs: {
      "label": "业主手机："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "maxlength": "11",
      "placeholder": "请输入业主手机号码"
    },
    model: {
      value: (_vm.yezhuPhone),
      callback: function($$v) {
        _vm.yezhuPhone = $$v
      },
      expression: "yezhuPhone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    staticClass: "demoFormInline"
  }, [_c('el-form-item', {
    staticClass: "selectflex",
    attrs: {
      "label": "案例封面："
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, [_vm._l((_vm.imgShopArr), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "display": "inline-block",
        "position": "relative"
      }
    }, [_c('img', {
      staticStyle: {
        "position": "absolute",
        "right": "7px",
        "top": "-8px",
        "width": "20px"
      },
      attrs: {
        "src": require("../../assets/img/aicon36.png")
      },
      on: {
        "click": function($event) {
          return _vm.deleteimg(index, item)
        }
      }
    }), _vm._v(" "), _c('img', {
      staticStyle: {
        "width": "80px",
        "height": "80px",
        "display": "inline-block",
        "margin-right": "15px"
      },
      attrs: {
        "src": item
      }
    })])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.imgShopArr.length < 5),
      expression: "imgShopArr.length<5"
    }],
    staticClass: "upload",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isdisabled),
      expression: "isdisabled"
    }],
    attrs: {
      "action": "",
      "show-file-list": false,
      "before-upload": _vm.beforeUploadShopIntroduction
    }
  }, [(_vm.zstpUrl) ? _c('img', {
    staticStyle: {
      "width": "80px",
      "height": "80px"
    },
    attrs: {
      "src": _vm.zstpUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1)], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v("建议上传图片尺寸为1:1，最多上传5张。")])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "selectflex",
    attrs: {
      "label": "视频(选填)："
    }
  }, [(_vm.videoSrc) ? _c('div', {
    staticClass: "videoClass"
  }, [_c('span', {
    staticClass: "previewingVideo",
    on: {
      "click": function($event) {
        return _vm.newSeevideo(_vm.videoSrc)
      }
    }
  }, [(_vm.videoImg) ? _c('img', {
    attrs: {
      "src": _vm.videoImg
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/img/spfm.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "iconcontainer"
  }, [_c('img', {
    staticClass: "playIcon",
    attrs: {
      "src": require("../../assets/img/play.png")
    }
  })])]), _vm._v(" "), (_vm.videoSrc) ? _c('img', {
    staticClass: "chahao",
    attrs: {
      "src": require("../../assets/img/aicon36.png")
    },
    on: {
      "click": function($event) {
        return _vm.delvideo()
      }
    }
  }) : _vm._e()]) : _c('el-upload', {
    staticClass: "avatar-uploader-zstp",
    attrs: {
      "action": "",
      "accept": "video/*",
      "before-upload": _vm.handleFile
    }
  }, [(_vm.videoFlag) ? _c('el-progress', {
    attrs: {
      "type": "circle",
      "percentage": _vm.videoUploadPercent,
      "width": 80,
      "height": 80
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v("视频格式仅支持: mp4. 视频大小不能超过 50MB !")])], 1)], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "xmxx"
  }, [_vm._v(" 主要使用建材 ")]), _vm._v(" "), _c('div', {
    staticClass: "contentDiv"
  }, [_c('el-form', {
    staticClass: "demoFormInline"
  }, [_c('el-form-item', {
    staticClass: "selectflex",
    attrs: {
      "label": "建材品类："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "visible-change": _vm.choiceBrandtype,
      "change": _vm.changeBrand
    },
    model: {
      value: (_vm.BrandTypeId),
      callback: function($$v) {
        _vm.BrandTypeId = $$v
      },
      expression: "BrandTypeId"
    }
  }, _vm._l((_vm.brandTypelist), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "selectflex",
    attrs: {
      "label": "建材品牌："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "visible-change": _vm.choiceBrand,
      "change": _vm.changeBra
    },
    model: {
      value: (_vm.BrandId),
      callback: function($$v) {
        _vm.BrandId = $$v
      },
      expression: "BrandId"
    }
  }, _vm._l((_vm.brandListarr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": _vm.bordersure
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "品类"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.brandTypeName
          }
        }, [_vm._v(_vm._s(scope.row.brandTypeName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "品牌"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.brandName
          }
        }, [_vm._v(_vm._s(scope.row.brandName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "使用场景"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.useScene
          }
        }, [_vm._v(_vm._s(scope.row.useScene))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticClass: "ahref",
          attrs: {
            "href": "javascript:;"
          },
          on: {
            "click": function($event) {
              return _vm.shanchu(scope)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-form', {
    staticClass: "demoFormInline"
  }, [_c('el-form-item', {
    staticClass: "selectflex",
    attrs: {
      "label": "使 用 场 景："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "textarea",
      "maxlength": "50",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.changjing),
      callback: function($$v) {
        _vm.changjing = $$v
      },
      expression: "changjing"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.addinfo()
      }
    }
  }, [_vm._v("增加")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "selectflex"
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "xmxx"
  }, [_vm._v(" 案例介绍 ")]), _vm._v(" "), _c('div', {
    staticClass: "contentDiv"
  }, [_c('wjEditor', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "desc": _vm.ExpIntroduce
    },
    on: {
      "change": _vm.contentChangeOne
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "xmxx"
  }, [_vm._v(" 本内容由我原创 ")]), _vm._v(" "), _c('div', {
    staticClass: "contentDiv"
  }, [_c('div', {
    staticClass: "youwo"
  }, [_c('span', [_c('el-switch', {
    attrs: {
      "active-color": "#F56C6C",
      "inactive-color": "#ddd"
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v("本人承诺本人账户中所上传的全部作品均系本人自主创作形成的原创内容，拥有合法有效、独立完整的著作权，不侵犯任何第三人的合法权益")])]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "gudingdibu"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "loading": _vm.loadingBut
    },
    on: {
      "click": function($event) {
        return _vm.emit()
      }
    }
  }, [_vm._v(_vm._s(_vm.loadingButText))])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.dialogVisiblesure,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisiblesure = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.showtype == 0 ? "您确定上架此商品吗?" : "您确定下价架此商品吗?"))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisiblesure = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.makesure()
      }
    }
  }, [_vm._v("确定")])], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.dialogVisiblesure,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisiblesure = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.isOnline == 0 ? "是否上架当前案例" : "是否下架当前案例"))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisiblesure = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.makesure()
      }
    }
  }, [_vm._v("确定")])], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "视频播放",
      "visible": _vm.videoVisible,
      "width": "30%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.videoVisible = $event
      },
      "close": _vm.closeVideo
    }
  }, [_c('video-player', {
    ref: "videoPlayer",
    staticClass: "video-player vjs-custom-skin",
    attrs: {
      "playsinline": true,
      "options": _vm.playerOptions
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择装修公司",
      "visible": _vm.dialogVisibleadd,
      "width": "25%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisibleadd = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": "装修公司："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择装修公司"
    },
    model: {
      value: (_vm.companyId),
      callback: function($$v) {
        _vm.companyId = $$v
      },
      expression: "companyId"
    }
  }, _vm._l((_vm.zxgsArr), function(item) {
    return _c('el-option', {
      key: item.shopid,
      attrs: {
        "label": item.shopname,
        "value": item.shopid
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisibleadd = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.gonext()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "600",
      "color": "#ffc500"
    }
  }, [_vm._v("写作小贴士")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "600",
      "color": "#888"
    }
  }, [_vm._v("A.关于前言，你可以说说")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "rideo"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#bcbbba"
    }
  }, [_vm._v("装修背后的故事")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_c('span', {
    staticClass: "rideo"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#bcbbba"
    }
  }, [_vm._v("为什么选择这种装修风格")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_c('span', {
    staticClass: "rideo"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#bcbbba"
    }
  }, [_vm._v("装修前要注意那些事项")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "600",
      "color": "#888"
    }
  }, [_vm._v("B.正文部分，有以下小Tips")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('span', {
    staticClass: "rideo",
    staticStyle: {
      "margin-top": "8px"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#bcbbba"
    }
  }, [_vm._v("介绍装修的基本信息（包括户型图、面积、装修费用、装修及入住时长等）")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "-10px",
      "display": "flex"
    }
  }, [_c('span', {
    staticClass: "rideo",
    staticStyle: {
      "margin-top": "8px"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#bcbbba"
    }
  }, [_vm._v("说说每个空间当初事怎么设计/布置的，为什么这样做")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "-10px",
      "display": "flex"
    }
  }, [_c('span', {
    staticClass: "rideo",
    staticStyle: {
      "margin-top": "8px"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#bcbbba"
    }
  }, [_vm._v("你也可以拖拽效果图模板调整段落顺序")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "-10px",
      "display": "flex"
    }
  }, [_c('span', {
    staticClass: "rideo",
    staticStyle: {
      "margin-top": "8px"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#bcbbba"
    }
  }, [_vm._v("大场景照喝丰富文字描述将会是你的方案更受欢迎")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "600",
      "color": "#888"
    }
  }, [_vm._v("C.在最后，你还可以分享")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "rideo"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#bcbbba"
    }
  }, [_vm._v("完工后业主的看法")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_c('span', {
    staticClass: "rideo"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#bcbbba"
    }
  }, [_vm._v("这次装修留下的遗憾")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_c('span', {
    staticClass: "rideo"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#bcbbba"
    }
  }, [_vm._v("想要给大家的建议/忠告")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b15e37f6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/storeManagement/decorationCases.vue
// module id = 1736
// module chunks = 3